import axios from 'axios';

// Configure axios defaults
// Use empty string for relative URLs (works with nginx proxy)
const API_URL = process.env.REACT_APP_API_URL || '';
const isDev = process.env.NODE_ENV === 'development';

axios.defaults.baseURL = API_URL;
axios.defaults.headers.common['Content-Type'] = 'application/json';
// CSRF Protection - custom header required by backend
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
// CRITICAL FIX: Set timeout to prevent infinite hanging requests
axios.defaults.timeout = 10000; // 10 seconds
// Wysyłaj httpOnly cookies (sesja JWT) z każdym requestem
axios.defaults.withCredentials = true;

// API URL configured: development mode uses relative URLs by default
// Authorization token jest teraz w httpOnly cookie - przeglądarka wysyła go automatycznie

// Add response interceptor for error handling
axios.interceptors.response.use(
  (response) => {
    // Cache invalidation: po mutacji wywal cached GET'y dla tego zasobu.
    // Strategia: bierzemy główny segment ścieżki (np. /api/tasks/123 → "tasks")
    // i wywalamy wszystko zawierające ten segment. Niedoskonałe ale wystarczy
    // dla typowego CRUD. Dla wielokierunkowych zależności (np. complete task
    // wpływa na /api/today/summary) komponent może wywołać refetch({force:true}).
    const method = response.config?.method?.toUpperCase();
    if (['POST', 'PUT', 'DELETE', 'PATCH'].includes(method)) {
      const url = response.config?.url || '';
      const segMatch = url.match(/\/api\/([^/?]+)/);
      const segment = segMatch?.[1];
      if (segment) {
        import('../redesign/lib/api').then(m => {
          if (m.invalidateCache) m.invalidateCache(`/api/${segment}`);
        }).catch(() => {});
      }
    }
    return response;
  },
  (error) => {
    if (isDev) {
      console.error(`API Error: ${error.config?.method?.toUpperCase()} ${error.config?.url} - ${error.response?.status || 'No response'}`);
    }
    return Promise.reject(error);
  }
);

/**
 * Buduje poprawny URL do zdjęcia z bazy danych.
 * Obsługuje różne formaty ścieżek:
 *   "uploads/tomato.jpg"       -> "/uploads/tomato.jpg"
 *   "/uploads/tomato.jpg"      -> "/uploads/tomato.jpg"
 *   "thumbs/tomato_thumb.jpg"  -> "/uploads/thumbs/tomato_thumb.jpg"
 *   null/undefined             -> null
 */
const getImageUrl = (path) => {
  if (!path) return null;

  // Już jest pełnym URL-em
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }

  // Znormalizuj ścieżkę
  let normalized = path;

  // Dodaj leading slash jeśli brak
  if (!normalized.startsWith('/')) {
    normalized = '/' + normalized;
  }

  // Upewnij się, że zaczyna się od /uploads/
  if (!normalized.startsWith('/uploads/')) {
    normalized = '/uploads' + normalized;
  }

  return `${API_URL}${normalized}`;
};

export default axios;
export { API_URL, getImageUrl };
